var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('ApplicationList_NoData_Title')))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n    "+_vm._s(_vm.$t('ApplicationList_NoData_Description'))+"\n  ")]),_vm._v(" "),_vm._t("actions")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc3ad18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/account/components/ApplicationListNoData.vue
// module id = null
// module chunks = 